<azavista-exported-element-wrapper>
    <div class="grouped-fields-view-container aza-pa-flex-row aza-pa-content-space-between aza-pa-half-gap">
        <h3 *ngIf="fieldsTitle" class="grouped-fields-view-title">{{ fieldsTitle }}</h3>
        <div class="aza-pa-flex-row aza-pa-half-gap">
            <azavista-input-field *ngIf="viewFieldValue" [field]="viewField" [value]="viewFieldValue"
                [editMode]="true" (valueChanged)="onViewValueChanged($event)" label="{{'SELECT_VIEW' | translate}}">
            </azavista-input-field>
            <azavista-flat-button *ngIf="currentView" [disabled]="!currentView.id"
                (click)="onCreateNewOrEditExistingClicked(false)" color="primary">
                <mat-icon class="material-icons-outlined">edit_outline</mat-icon>
                <span translate>EDIT_VIEW</span>
            </azavista-flat-button>
            <azavista-flat-button *ngIf="canCreateView" (click)="onCreateNewOrEditExistingClicked(true)" color="primary">
                <mat-icon class="material-icons-outlined">add</mat-icon>
                <span translate>CREATE_VIEW</span>
            </azavista-flat-button>
        </div>
    </div>
</azavista-exported-element-wrapper>
